// extracted by mini-css-extract-plugin
export default {"card":"EventCountCard_card__UQnEl","card__title":"EventCountCard_card__title__+-9vH","card__body":"EventCountCard_card__body__nltF6"};